import React from 'react';
import { Icon } from './Icon.js';
export const IconCheck3Fill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("path", { d: "M6.5,15h-.003c-.279,0-.535-.157-.663-.405-1.054-2.033-2.236-3.689-3.614-5.064-.293-.292-.294-.767,0-1.061,.292-.294,.767-.294,1.061,0,1.203,1.2,2.264,2.591,3.221,4.227,2.265-3.942,5.054-7.15,8.304-9.549,.333-.246,.803-.175,1.049,.158s.175,.803-.158,1.049c-3.392,2.504-6.263,5.951-8.532,10.247-.13,.246-.385,.399-.663,.399Z", fill: "currentColor" })));
};
//# sourceMappingURL=IconCheck3Fill18.js.map